export default __webpack_public_path__ + "static/media/pharmacy_low.e68295eb.svg";